var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn main-btn py-2 mt-2",on:{"click":_vm.AddToCart}},[_vm._v("Add to cart")])])}
var staticRenderFns = []

export { render, staticRenderFns }